class MultiStreamSearchController {
  constructor() {
    this.currentPage = 1;
    this.productsPerPage = 10;
    this.productSectionId = '';
    this.contentSectionId = '';
    
    this.init();
  }

  init() {
    this.parseURLState();
    this.extractSectionIds();
    this.setupEventListeners();
    this.setupFilterListeners();
    this.applyClientSidePagination();
    this.updatePaginationState();
    this.updatePaginationLinks();
  }

  parseURLState() {
    const urlParams = new URLSearchParams(window.location.search);
    this.currentPage = parseInt(urlParams.get('page')) || 1;
    this.productsPerPage = parseInt(urlParams.get('per_page')) || 10;
  }

  extractSectionIds() {
    const productContainer = document.getElementById('product-results-container');
    const contentContainer = document.getElementById('content-results-container');
    
    if (productContainer) {
      this.productSectionId = productContainer.dataset.sectionId;
    }
    if (contentContainer) {
      this.contentSectionId = contentContainer.dataset.sectionId;
    }
  }

  setupEventListeners() {
    const paginationContainer = document.getElementById('pagination-container');
    if (paginationContainer) {
      paginationContainer.addEventListener('click', (e) => {
        e.preventDefault();
        
        const link = e.target.closest('a');
        if (!link) return;
        
        const dataPage = link.getAttribute('data-page');
        if (dataPage) {
          const targetPage = parseInt(dataPage);
          if (targetPage !== this.currentPage) {
            const url = new URL(window.location.href);
            url.searchParams.set('page', targetPage.toString());
            window.location.href = url.toString();
          }
          return;
        }
        
        const href = link.getAttribute('href');
        if (!href) return;
        
        const url = new URL(href, window.location.origin);
        const targetPage = parseInt(url.searchParams.get('page')) || 1;
        
        if (targetPage !== this.currentPage) {
          window.location.href = href;
        }
      });
    }

  }

  setupFilterListeners() {
    this.lastUrlParams = new URLSearchParams(window.location.search).toString();
    this.isUpdatingFromURL = false;
    
    window.addEventListener('popstate', () => {
      this.handleURLChange();
    });
    
    this.observeURLChanges();
    this.observeFilterChips();
    
    document.addEventListener('change', (e) => {
      if (this.isUpdatingFromURL) return;
      
      if (e.target.type === 'checkbox' && e.target.name && e.target.name.includes('filter')) {
        const form = e.target.closest('form');
        if (form) {
          this.handleFilterChange(form);
        }
      }
      
      if (e.target.name === 'sort_by') {
        this.handleSortChange(e.target);
      }
      
      if (e.target.name && e.target.name.includes('filter.v.price')) {
        const form = e.target.closest('form');
        if (form) {
          this.handleFilterChange(form);
        }
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.tagName === 'A' && e.target.href && e.target.href.includes('filter')) {
        this.handleFacetChange(e.target);
      }
    });
  }

  async handleFilterChange(form) {
    const formData = new FormData(form);
    const url = new URL(form.action || window.location.href);
    
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value && value.trim() !== '') {
        params.append(key, value);
      }
    }
    
    const existingParams = new URLSearchParams(url.search);
    for (const [key, value] of existingParams.entries()) {
      if (!params.has(key)) {
        params.append(key, value);
      }
    }
    
    url.search = params.toString();
    await this.updateSearchResults(url.toString());
  }

  async handleSortChange(select) {
    const form = select.closest('form');
    if (form) {
      await this.handleFilterChange(form);
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      await this.updateSearchResults(url.toString());
    }
  }

  async handleFacetChange(link) {
    const url = new URL(link.href);

    await this.updateSearchResults(url.toString());
  }

  async updateSearchResults(url) {
    try {
      this.showLoadingState();
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // 페이지네이션 컨테이너만 업데이트 (검색 결과는 그대로 유지)
      this.updateSearchResultsArea(doc, false, false, true);
      
      // URL 업데이트 (히스토리 API 사용)
      window.history.pushState({}, '', url);
      
      // 필터 변경 시 항상 1페이지로 리셋
      this.currentPage = 1;
      
      // 페이지네이션 상태 업데이트 (순서 중요)
      this.parseURLState();
      this.updatePaginationState();
      this.updatePaginationLinks();
      this.applyClientSidePagination();
      
    } catch (error) {
      // 오류 시 전체 페이지 새로고침으로 폴백
      window.location.href = url;
    } finally {
      this.hideLoadingState();
    }
  }

  updateSearchResultsArea(doc, updateProducts = true, updateContent = true, updatePagination = true) {
    if (updateProducts) {
      const newProductContainer = doc.querySelector('#product-results-container');
      const currentProductContainer = document.querySelector('#product-results-container');
      if (newProductContainer && currentProductContainer) {
        currentProductContainer.innerHTML = newProductContainer.innerHTML;
      }
    }
    
    if (updateContent) {
      const newContentContainer = doc.querySelector('#content-results-container');
      const currentContentContainer = document.querySelector('#content-results-container');
      if (newContentContainer && currentContentContainer) {
        currentContentContainer.innerHTML = newContentContainer.innerHTML;
      }
    }
    
    if (updatePagination) {
      const newPaginationContainer = doc.querySelector('#pagination-container');
      const currentPaginationContainer = document.querySelector('#pagination-container');
      if (newPaginationContainer && currentPaginationContainer) {
        currentPaginationContainer.innerHTML = newPaginationContainer.innerHTML;
      }
    }
  }

  observeURLChanges() {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    
    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      setTimeout(() => this.handleURLChange(), 0);
    };
    
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      setTimeout(() => this.handleURLChange(), 0);
    };
  }

  observeFilterChips() {
    const activeFiltersContainer = document.getElementById('FacetFiltersActive');
    if (!activeFiltersContainer) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          this.handleURLChange();
        }
      });
    });

    observer.observe(activeFiltersContainer, {
      childList: true,
      subtree: true
    });
  }

  handleURLChange() {
    const currentUrlParams = new URLSearchParams(window.location.search).toString();
    
    if (currentUrlParams === this.lastUrlParams) {
      return;
    }
    
    this.lastUrlParams = currentUrlParams;
    this.isUpdatingFromURL = true;
    
    this.updateFilterFormFromURL();
    
    this.updateSearchResults(window.location.href).finally(() => {
      this.isUpdatingFromURL = false;
    });
  }

  updateFilterFormFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    this.updateCheckboxes(urlParams);
    this.updateSortSelect(urlParams);
    this.updatePriceInputs(urlParams);
  }

  updateCheckboxes(urlParams) {
    const checkboxes = document.querySelectorAll('input[type="checkbox"][name*="filter"]');
    checkboxes.forEach(checkbox => {
      const paramName = checkbox.name;
      const paramValue = urlParams.get(paramName);
      const shouldBeChecked = paramValue !== null && paramValue === checkbox.value;
      
      if (checkbox.checked !== shouldBeChecked) {
        checkbox.checked = shouldBeChecked;
      }
    });
  }

  updateSortSelect(urlParams) {
    const sortSelect = document.querySelector('select[name="sort_by"]');
    if (sortSelect) {
      const sortValue = urlParams.get('sort_by');
      if (sortValue && sortSelect.value !== sortValue) {
        sortSelect.value = sortValue;
      }
    }
  }

  updatePriceInputs(urlParams) {
    const priceInputs = document.querySelectorAll('input[name*="filter.v.price"]');
    priceInputs.forEach(input => {
      const paramName = input.name;
      const paramValue = urlParams.get(paramName);
      if (paramValue !== null && input.value !== paramValue) {
        input.value = paramValue;
      }
    });
  }

  showLoadingState() {
    const containers = ['product-results-container', 'content-results-container', 'pagination-container'];
    containers.forEach(id => {
      const container = document.getElementById(id);
      if (container) {
        container.style.opacity = '0.5';
        container.style.pointerEvents = 'none';
      }
    });
  }

  hideLoadingState() {
    const containers = ['product-results-container', 'content-results-container', 'pagination-container'];
    containers.forEach(id => {
      const container = document.getElementById(id);
      if (container) {
        container.style.opacity = '1';
        container.style.pointerEvents = 'auto';
      }
    });
  }

  applyClientSidePagination() {
    const productsContainer = document.getElementById('ProductsList');
    const contentContainer = document.getElementById('ContentList');
    
    if (productsContainer) {
      this.applyPaginationToContainer(productsContainer, this.currentPage, 'product');
    }
    
    if (contentContainer) {
      this.applyPaginationToContainer(contentContainer, this.currentPage, 'content');
    }
  }

  applyPaginationToContainer(container, page, type) {
    const allItems = Array.from(container.children);
    allItems.forEach(item => {
      item.style.display = '';
    });
    
    const startIndex = (page - 1) * this.productsPerPage;
    const endIndex = Math.min(startIndex + this.productsPerPage, allItems.length);
    
    allItems.forEach((item, index) => {
      if (index >= startIndex && index < endIndex) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  updatePaginationState() {
    const paginationContainer = document.getElementById('pagination-container');
    
    if (paginationContainer) {
      const productsContainer = document.getElementById('ProductsList');
      const contentContainer = document.getElementById('ContentList');
      const totalProducts = productsContainer ? productsContainer.children.length : 0;
      const totalContent = contentContainer ? contentContainer.children.length : 0;
      const maxPage = Math.max(
        Math.ceil(totalProducts / this.productsPerPage),
        Math.ceil(totalContent / this.productsPerPage)
      );
      
      if (maxPage <= 1) {
        paginationContainer.style.display = 'none';
        return;
      } else {
        paginationContainer.style.display = '';
      }
      
      // 모든 페이지 링크를 다시 생성하여 현재 상태 반영
      this.recreatePaginationLinks(maxPage);
      
      // 다음/이전 버튼 상태 업데이트
      const nextButton = paginationContainer.querySelector('.pagination__item--next');
      const prevButton = paginationContainer.querySelector('.pagination__item--previous');
      
      if (nextButton) {
        nextButton.style.display = this.currentPage >= maxPage ? 'none' : '';
      }
      
      if (prevButton) {
        prevButton.style.display = this.currentPage <= 1 ? 'none' : '';
      }
    }
  }

  recreatePaginationLinks(maxPage) {
    const paginationContainer = document.getElementById('pagination-container');
    if (!paginationContainer) return;
    
    // 기존 페이지 번호 링크들 제거
    const existingPageLinks = paginationContainer.querySelectorAll('a.pagination__link[data-page]');
    existingPageLinks.forEach(link => {
      const li = link.parentNode;
      if (li) {
        li.remove();
      }
    });
    
    // 새로운 페이지 번호 링크들 생성
    const ul = paginationContainer.querySelector('ul');
    if (ul) {
      // 이전 버튼 다음에 페이지 번호들 삽입
      const prevButton = ul.querySelector('.pagination__item--previous');
      let insertAfter = prevButton ? prevButton.parentNode : null;
      
      for (let i = 1; i <= maxPage; i++) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '';
        a.className = 'pagination__item pagination__item--page pagination__link';
        a.setAttribute('data-page', i.toString());
        a.setAttribute('aria-label', `Page ${i}`);
        a.textContent = i.toString();
        
        if (i === this.currentPage) {
          const span = document.createElement('span');
          span.className = 'pagination__item pagination__item--current background-2 pagination__item--page';
          span.setAttribute('aria-current', 'page');
          span.setAttribute('aria-disabled', 'true');
          span.setAttribute('role', 'link');
          span.textContent = i.toString();
          li.appendChild(span);
        } else {
          li.appendChild(a);
        }
        
        if (insertAfter) {
          insertAfter.parentNode.insertBefore(li, insertAfter.nextSibling);
        } else {
          ul.appendChild(li);
        }
        insertAfter = li;
      }
    }
  }

  updatePaginationLinks() {
    const paginationContainer = document.getElementById('pagination-container');
    
    if (paginationContainer) {
      const currentUrl = new URL(window.location.href);
      const baseUrl = currentUrl.origin + currentUrl.pathname;
      const searchParams = new URLSearchParams(currentUrl.search);
      
      const allLinks = paginationContainer.querySelectorAll('a[data-page]');
      allLinks.forEach(link => {
        const targetPage = link.getAttribute('data-page');
        if (targetPage) {
          searchParams.set('page', targetPage);
          const newUrl = baseUrl + '?' + searchParams.toString();
          link.href = newUrl;
        }
      });
    }
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new MultiStreamSearchController();
});